import { render } from "./GivingForm.vue?vue&type=template&id=5aaa7e53&scoped=true"
import script from "./GivingForm.vue?vue&type=script&lang=js"
export * from "./GivingForm.vue?vue&type=script&lang=js"

import "./GivingForm.vue?vue&type=style&index=0&id=5aaa7e53&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aaa7e53"]])

export default __exports__